import React, { Component } from "react";

import { Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import CustomBreadcrumbs from "../../../../components/Common/CustomBreadcrumbs";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import queryString from "query-string";
import MiniWidget from "../../../../components/MiniWidget/index";
import CustomCurrencySelect from "../../../../components/CustomCurrencySelect/CustomCurrencySelect";
import {
  getQualityCampStats,
  getQualityFilters,
  getQualityWidgets,
  setQualityTable,
  setQualityEvents,
  setQualityFilters,
  setNonCahortReportDate,
  RequestDataUpdate,
  setQualityCampStats,
  getReportEventsStats
} from "../../../../store/reporting/actions";
import { getApplications } from "../../../../store/apps/actions";
import { getEvents, setEvents } from "../../../../store/events/actions";
import ReactTableForm from "../../../../components/Common/ReactTableForm";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {
  getCurrentDay,
  getSelectedMonthAgo,
  formatNumbersForTable,
} from "./../../../../helpers/utils";
import DefaultMultipleSelect from "./../../../../components/DefaultMultipleSelect/DefaultMultipleSelect";
import DynamicFormToFilter from "./../../../../components/forms/DynamicFormToFilter";
import ModifiedMetaTags from '../../../../components/ModifiedMetaTags/index';
import ProgressDataBudget from "./ProgressDataBudget";

class NonCohortReportTable extends Component {
  constructor(props) {
    super(props);
    this.styleNumbers = {
      textAlign: "center",
      width: "auto",
      verticalAlign: "middle",
    };
    this.campaignStatsColumns = [
      {
        Header: "Campaign name",
        src: "campaign_name",
        style: {
          ...this.styleNumbers,
          minWidth: 130,
        },
        accessor: row => (
          <span data-toggle="tooltip" title={row.campaign_name}>
            {row?.campaign_name ? row?.campaign_name.substr(0, 23) + "..." : 'N/A'}
          </span>
        ),
        isSorted: true,
      },
      {
        Header: "Campaign ID",
        src: "campaign_id",
        style: {
          ...this.styleNumbers,
          minWidth: 115,
        },
        accessor: row => (
          <Link
            to={{
              pathname: `/quality-report/${this.props.match.params.app_id}/${this.props.match.params.media_source}/${row.campaign_id}`,
              state: {
                app_name: this.state.app_name,
              },
            }}
          >
            {row.campaign_id}
          </Link>
        ),
        isSorted: true,
      },
      {
        Header: "Payment",
        src: "payment",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.payment),
        isSorted: true,
      },
      {
        Header: "Spend",
        src: "spend",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.spend),
        isSorted: true,
      },
      {
        Header: "Profit",
        src: "profit",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.profit),
        isSorted: true,
      },
      {
        Header: "Cashback",
        src: "cashback",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.cashback),
        isSorted: true,
      },
      {
        Header: "Clicks",
        src: "clicks",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.clicks),
        isSorted: true,
      },
      {
        Header: "Impressions",
        src: "shows",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.shows),
        isSorted: true,
      },
      {
        Header: "Installs",
        src: "installs",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.installs),
        isSorted: true,
      },
      {
        Header: "CTR",
        src: "CTR",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.CTR) + "%",
        isSorted: true,
      },
      {
        Header: "CPC",
        src: "CPC",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.CPC),
        isSorted: true,
      },
      {
        Header: "CPM",
        src: "CPM",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.CPM),
        isSorted: true,
      },
      {
        Header: "CR",
        src: "CR",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row => formatNumbersForTable(row.CR),
        isSorted: true,
      },
      {
        Header: "CPI",
        src: "CPI_post_click_plus_post_view",
        style: {
          ...this.styleNumbers,
          minWidth: 100,
        },
        accessor: row =>
          formatNumbersForTable(row.CPI_post_click_plus_post_view),
        isSorted: true,
      },
    ];

    this.campaignBreadCrumbs = [
      {
        link: `/quality-report/${this.props.match.params.app_id}`,
        title: "All Media Sources",
      },
      {
        active: true,
        title: this.props.match.params.media_source,
      },
    ];

    this.state = {
      reports: [
        {
          icon: "mdi mdi-eye-check-outline",
          title: "Impressions",
          value: 0,
          badgeValue: `Undefined`,
          color: "danger",
          desc: "From previous period",
          type: "WITH_DIFFERENCE",
        },
        {
          icon: "mdi mdi-cursor-default-click-outline",
          title: "Clicks",
          value: 0,
          badgeValue: `Undefined`,
          color: "danger",
          desc: "From previous period",
          type: "WITH_DIFFERENCE",
        },
        {
          icon: "mdi mdi-contactless-payment-circle-outline",
          title: "Payment",
          value: 0,
        },
        {
          icon: "mdi mdi-cash-100",
          title: "Spend",
          value: 0,
        },
        {
          icon: "mdi mdi-cash-plus",
          title: "Profit",
          value: 0,
        },
      ],
      clients: [],
      breadcrumbs: [],
      columns: [],
      events: [],
      currency: [
        { label: "USD", value: "USD" },
        { label: "EUR", value: "EUR" },
      ],
      app_name: undefined,
      selectedEvents: [],
      filterSearch: null,
    };

    this.searchTimer = null;
  }

  componentDidMount() {
    const app_id = this.props.match.params.app_id;
    const media_source = this.props.match.params.media_source;

    this.setState({ app_id: app_id });
    const data = this.props.camp_stats;

    if (this.props.history.location.state == undefined) {
      this.props.getApplications(this.props.apps);
    }

    if (this.props.nonCahortDate === null) {
      let parsedSearch = queryString.parse(this.props.history.location.search);
      data.start_date = parsedSearch.start_date || getSelectedMonthAgo(2);
      data.end_date = parsedSearch.end_date || getCurrentDay();
      data.currency = parsedSearch.currency || this.state.currency[0].value;
      data.app_id = app_id;
      data.media_source = media_source;
      data.page = parsedSearch.page || 1;
      data.sizePerPage = parsedSearch.size || 10;

      let formQueryString = queryString.stringify(
        Object.assign(parsedSearch, {
          start_date: data.start_date,
          end_date: data.end_date,
          page: data.page,
          size: data.sizePerPage,
          currency: data.currency,
        })
      );
      this.props.getQualityFilters(data);
      // this.props.getQualityCampStats(data);
      this.props.setNonCahortReportDate(data);
      this.props.getQualityWidgets(data);
      this.setState({ app_name: this.props.history.location.state?.app_name });
      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
    } else {
      let parsedSearch = queryString.parse(this.props.history.location.search);
      let cahortDate = this.props.nonCahortDate;
      let updateCahort = {};
      updateCahort.app_id = app_id;
      updateCahort.media_source = media_source;
      updateCahort.start_date = cahortDate.start_date;
      updateCahort.end_date = cahortDate.end_date;
      updateCahort.page = cahortDate.page || 1;
      updateCahort.sizePerPage = cahortDate.sizePerPage || 10;
      updateCahort.currency = cahortDate.currency;

      let parsedObject = {
        start_date: updateCahort.start_date,
        end_date: updateCahort.end_date,
        page: updateCahort.page || 1,
        size: updateCahort.sizePerPage,
        currency: updateCahort.currency,
      };

      let formQueryString = "";

      if (cahortDate?.mediabuyers) {
        updateCahort.mediabuyers = cahortDate.mediabuyers;
        formQueryString = queryString.stringify(
          Object.assign(parsedSearch, {
            ...parsedObject,
            mediabuyers: updateCahort.mediabuyers.split(","),
          })
        );
      } else {
        formQueryString = queryString.stringify(
          Object.assign(parsedSearch, {
            ...parsedObject,
          })
        );
      }

      this.props.getQualityFilters(updateCahort);
      this.props.getQualityCampStats(updateCahort);
      this.props.getQualityWidgets(updateCahort);
      this.setState({
        app_name: this.props.history.location.state?.app_name,
      });
      this.props.history.location.search = formQueryString;
      this.props.history.replace(this.props.history.location);
    }

    this.props.getEvents({
      tracker_app_id: app_id,
    });

    if (this.props.quality_table === null) {
      this.props.setQualityTable(this.campaignStatsColumns);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.filterSearch !== this.state.filterSearch) {
      this.onFiltersChange(undefined, this.state.filterSearch);
    }

    if (prevProps.camp_stats !== this.props.camp_stats) {
      this.props.events.length <= 0 &&
        this.props.getEvents({
          tracker_app_id: this.props.match.params.app_id,
        });
    }

    if (prevState.app_name !== this.state.app_name) {
      let updBreadcrumbs = this.campaignBreadCrumbs;
      updBreadcrumbs[0]["state"] = { app_name: this.state.app_name };

      this.props.setQualityTable(this.campaignStatsColumns);
      this.setState({
        app_name: this.state.app_name,
        breadcrumbs: updBreadcrumbs,
      });
    }

    if (prevProps.apps !== this.props.apps) {
      let currentSearch = queryString.parse(this.props.history.location.search);
      let appName = this.props.apps.results.find(
        app => app.app_id === this.props.match.params.app_id
      ).name;
      this.setState({ app_name: appName });
      this.props.history.location.search = queryString.stringify(currentSearch);
      this.props.history.replace(this.props.history.location);
    }

    if (prevProps.quality_widgets !== this.props.quality_widgets) {
      const widgets = this.props.quality_widgets[0];
      this.setState({
        reports: [
          {
            icon: "mdi mdi-eye-check-outline",
            title: "Impressions",
            value: widgets?.shows_sum || 0,
            badgeValue:
              widgets?.shows_change > 0
                ? `+ ${widgets?.shows_change}%`
                : widgets?.shows_change !== undefined
                  ? `- ${widgets?.shows_change}%`
                  : `Undefined`,
            color: widgets?.shows_change > 0 ? "success" : "danger",
            desc: "From previous period",
            type: "WITH_DIFFERENCE",
          },
          {
            icon: "mdi mdi-cursor-default-click-outline",
            title: "Clicks",
            value: widgets?.clicks_sum || 0,
            badgeValue:
              widgets?.clicks_change > 0
                ? `+ ${widgets?.clicks_change}%`
                : widgets?.clicks_change !== undefined
                  ? `- ${widgets?.clicks_change}%`
                  : `Undefined`,
            color: widgets?.clicks_change > 0 ? "success" : "danger",
            desc: "From previous period",
            type: "WITH_DIFFERENCE",
          },
          {
            icon: "mdi mdi-contactless-payment-circle-outline",
            title: "Payment",
            value: widgets?.payment_sum || 0,
          },
          {
            icon: "mdi mdi-cash-100",
            title: "Spend",
            value: widgets?.spend_sum || 0,
          },
          {
            icon: "mdi mdi-cash-plus",
            title: "Profit",
            value: widgets?.profit_sum || 0,
          },
        ],
      });
    }

    if (this.props.quality_events !== prevProps.quality_events) {
      let updated_events = this.campaignStatsColumns.concat(
        this.props.quality_events
      );
      this.props.setQualityTable(updated_events);
    }
  }

  componentWillUnmount() {
    this.props.setQualityEvents([]);
    this.props.setQualityTable(null);
    this.props.setQualityFilters({});
    this.props.setEvents([]);
    this.setState({ selectedEvents: [] })
    this.props.setQualityCampStats({
      ...this.props.camp_stats,
      results: [],
    });
  }

  onTableChange = data => {
    const prevSearch = queryString.parse(this.props.history.location.search);

    let formQueryString = queryString.stringify(
      Object.assign(prevSearch, {
        page: data.page,
        size: data.sizePerPage,
      })
    );

    let campData = this.props.camp_stats;
    let cahortDate = this.props.nonCahortDate;

    campData.page = data.page;
    campData.sizePerPage = data.sizePerPage;
    campData.ordering = data?.ordering;

    this.props.getQualityCampStats(campData, {
      start_date: campData.start_date,
      end_date: campData.end_date,
      grouping: 'campaign',
      currency: cahortDate?.currency || "USD",
      event_name: [this.state.selectedEvents.map(i => i.label)].join(','),
      tracker_app_id: this.props.match.params.app_id,
    });

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
  };

  onFiltersChange = (type, filter, filter_type) => {
    const prevSearch = queryString.parse(this.props.history.location.search);
    const data = this.props.camp_stats;

    let events_params = {};

    let check =
      data.start_date === filter.start_date &&
      data.end_date === filter.end_date;

    data.start_date = filter.start_date;
    data.end_date = filter.end_date;
    data.app_id = this.props.match.params.app_id;
    data.media_source = this.props.match.params.media_source;

    let formQueryString = queryString.stringify(
      Object.assign(prevSearch, filter)
    );

    this.props.history.location.state !== undefined &&
      this.setState({ app_name: this.props.history.location.state.app_name });
    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);

    switch (filter_type) {
      case "campaign_ids":
        data.campaign_ids = filter.campaign_ids.join();
        break;
      case "campaign_names":
        data.campaign_names = filter.campaign_names.join();
        break;
      case "mediabuyers":
        data.mediabuyers = filter.mediabuyers.join();
        break;
    }

    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      if (!check || filter_type !== undefined) {
        type === "date" && this.props.getQualityWidgets(data);
        this.props.setNonCahortReportDate(data);

        this.props.getQualityCampStats(data, {
          start_date: data.start_date,
          end_date: data.end_date,
          grouping: 'campaign',
          currency: data?.currency || "USD",
          event_name: [this.state.selectedEvents.map(i => i.label)].join(','),
          tracker_app_id: data.app_id,
        });
        this.props.history.location.search = formQueryString;
        this.props.history.replace(this.props.history.location);
      }
    }, 100);
  };

  eventListener = data => {
    let filteredData = [];
    let prevHistory = queryString.parse(this.props.history.location.search);
    let comp_ids = []
    let params = {};
    let campData = this.props.camp_stats;
    let cahortDate = this.props.nonCahortDate;

    if (campData.results.length > 0) {
      campData.results.map(i => {
        comp_ids.push(i?.campaign_id)
      })

      params = {
        campaign_id: comp_ids.join(','),
        start_date: campData?.start_date,
        end_date: campData?.end_date,
        grouping: 'campaign',
        currency: cahortDate?.currency || "USD",
        event_name: [data.map(i => i.label)].join(','),
        tracker_app_id: this.props.match.params.app_id,
      }

      this.props.getReportEventsStats(params);
    }

    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        start_date: this.props.nonCahortDate.start_date,
        end_date: this.props.nonCahortDate.end_date,
        event_id: filteredData,
      })
    );

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);

    this.setState({
      selectedEvents: data,
    })
  };

  onCurrencyChange = data => {
    const updateData = this.props.camp_stats;
    let prevHistory = queryString.parse(this.props.history.location.search);
    let formQueryString = queryString.stringify(
      Object.assign(prevHistory, {
        start_date: this.props.nonCahortDate.start_date,
        end_date: this.props.nonCahortDate.end_date,
        currency: data.value,
      })
    );
    updateData.currency = data.value;

    this.props.history.location.search = formQueryString;
    this.props.history.replace(this.props.history.location);
    this.props.setNonCahortReportDate(updateData);
    this.props.getQualityWidgets(updateData);
    this.props.getQualityCampStats(updateData, {
      start_date: updateData.start_date,
      end_date: updateData.end_date,
      grouping: 'campaign',
      currency: updateData?.currency || "USD",
      event_name: [this.state.selectedEvents.map(i => i.label)].join(','),
      tracker_app_id: this.props.match.params.app_id,
    });
  };

  updateReportData = () => {
    this.props.RequestDataUpdate({
      date_from: this.props.nonCahortDate.start_date,
      date_to: this.props.nonCahortDate.end_date,
      app_id: this.props.match.params.app_id,
    });
  };

  render() {
    const widgetData = this.props.quality_widgets;

    return (
      <React.Fragment>
        <div className="page-content">
          <ModifiedMetaTags title={`${this.state?.app_name || 'Quality non cohort report'} | Mobihunter`} />

          <Container fluid>
            {this.state.app_name !== undefined && (
              <>
                <Breadcrumbs
                  title="Quality non cohort report"
                  breadcrumbItem={this.state.app_name}
                  link="/quality-report"
                />{" "}
                <DynamicFormToFilter
                  permissions={this.props.permissions}
                  onFiltersChange={this.onFiltersChange}
                  report_type="quality-report"
                  updateReportData={this.updateReportData}
                  filtersFields={[
                    {
                      filterData:
                        this.props.quality_filters?.campaign_ids || [],
                      plug: "Campaign ID...",
                      filterType: "campaign_ids",
                    },
                    {
                      filterData:
                        this.props.quality_filters?.campaign_names || [],
                      plug: "Campaign names...",
                      filterType: "campaign_names",
                    },
                    // {
                    //   filterData:
                    //     (this.props.quality_filters?.media_buyers &&
                    //       formattedObjectsForFilter(
                    //         this.props.quality_filters,
                    //         "media_buyers"
                    //       )) ||
                    //     [],
                    //   plug: "Media buyers...",
                    //   filterType: "mediabuyers",
                    // },
                  ]}
                  selectedDate={
                    Object.keys(
                      queryString.parse(this.props.history.location.search)
                    ).length == 0
                      ? this.props.nonCahortDate
                      : queryString.parse(this.props.history.location.search)
                  }
                  filtered_by={[
                    "campaign_ids",
                    "campaign_names",
                    // "mediabuyers",
                  ]}
                  filtered_params={queryString.parse(
                    this.props.history.location.search
                  )}
                />
                <ProgressDataBudget widgetData={widgetData} nonCahortDate={this.props.nonCahortDate} />
                <Col xl={12}>
                  <Row>
                    <MiniWidget
                      data={this.state.reports}
                      loading={this.props.widget_loader}
                    />
                  </Row>
                </Col>
                <Row>
                  <Col className="col-12">
                    <Card>
                      <CardBody>
                        <Row className="justify-content-between align-middle">
                          <Col xs={6}>
                            <h4 className="mb-3">Quality non cohort report</h4>
                            <CustomBreadcrumbs
                              breadcrumbItem={this.state.breadcrumbs}
                            />
                          </Col>
                          <Col xs={6} className="align-content-end">
                            <Form className="row align-items-center float-end ms-1">
                              <div className="col-sm-auto">
                                <CustomCurrencySelect
                                  options={this.state.currency}
                                  onChange={this.onCurrencyChange}
                                  defaultValue={queryString.parse(
                                    this.props.history.location.search
                                  )}
                                />
                              </div>
                            </Form>
                            <Form className="row align-items-center float-end">
                              <div className="col-sm-4">
                                <DefaultMultipleSelect
                                  options={this.props.events.map(
                                    ({ value, label, checked }) => ({
                                      key: value,
                                      text: label,
                                      checked,
                                    })
                                  )}
                                  filtered_params={queryString.parse(
                                    this.props.history.location.search
                                  )}
                                  onChange={this.eventListener}
                                  filtered_by="event_id"
                                  plug="Select events.."
                                  search
                                />
                              </div>
                            </Form>
                          </Col>
                        </Row>
                        {this.props.quality_table !== null && (
                          <ReactTableForm
                            columns={this.props.quality_table}
                            data={this.props.camp_stats}
                            onTableChange={this.onTableChange}
                            // loading={this.props.stats_loader}
                            firstIsSticky
                          />
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </>
            )}
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

NonCohortReportTable.propTypes = {
  history: PropTypes.any,
  match: PropTypes.shape({
    params: PropTypes.shape({
      app_id: PropTypes.node,
      media_source: PropTypes.string,
    }).isRequired,
  }).isRequired,
  getQualityCampStats: PropTypes.func.isRequired,
  setQualityCampStats: PropTypes.func.isRequired,
  camp_stats: PropTypes.any.isRequired,
  quality_filters: PropTypes.any,
  quality_widgets: PropTypes.any,
  quality_table: PropTypes.any,
  quality_events: PropTypes.any,
  nonCahortDate: PropTypes.any,
  events: PropTypes.any,
  apps: PropTypes.any,
  loading: PropTypes.bool,
  widget_loader: PropTypes.bool,
  stats_loader: PropTypes.bool,
  getEvents: PropTypes.func.isRequired,
  getQualityFilters: PropTypes.func.isRequired,
  getQualityWidgets: PropTypes.func.isRequired,
  setQualityTable: PropTypes.func.isRequired,
  setQualityEvents: PropTypes.func.isRequired,
  setNonCahortReportDate: PropTypes.func.isRequired,
  getApplications: PropTypes.func.isRequired,
  setQualityFilters: PropTypes.func.isRequired,
  RequestDataUpdate: PropTypes.func.isRequired,
  getReportEventsStats: PropTypes.func.isRequired,
  setEvents: PropTypes.func.isRequired,
  permissions: PropTypes.any,
};

const mapStateToProps = state => ({
  apps: state.Apps.data,
  camp_stats: state.Reporting.camp_stats,
  quality_filters: state.Reporting.quality_filters,
  quality_widgets: state.Reporting.quality_widgets,
  quality_table: state.Reporting.quality_table,
  quality_events: state.Reporting.quality_events,
  nonCahortDate: state.Reporting.nonCahortDate,
  events: state.Events.events,
  loading: state.Reporting.loading,
  widget_loader: state.Reporting.widget_loader,
  stats_loader: state.Reporting.quality_camp_stats_loader,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getQualityCampStats,
  getQualityFilters,
  getQualityWidgets,
  setQualityTable,
  setQualityEvents,
  setNonCahortReportDate,
  getEvents,
  getApplications,
  setQualityFilters,
  RequestDataUpdate,
  setQualityCampStats,
  getReportEventsStats,
  setEvents
})(NonCohortReportTable);
